import script from "./UserReferrals.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserReferrals.vue?vue&type=script&setup=true&lang=ts"

import "./UserReferrals.vue?vue&type=style&index=0&id=7e06f09c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e06f09c"]])

export default __exports__